<template>
  <div
    class="border-solid border-0 border-b border-gray-600 flex flex-row flex-wrap items-center pb-2"
    role="row"
  >
    <div v-if="hasActionBoxes">
      <doe-action-box
        identifier="selectAll"
        :isSelected="isSelected"
        :isPartial="isAnySelected"
        ariaLabel="Select all child names"
        @input="updateAllSelectedItems($event)"
      />
    </div>
    <div v-if="isAnySelected" class="flex-1" role="columnheader">
      <doe-button
        v-for="(action, index) in filteredActions"
        :prefix="action.icon"
        size="mini"
        :key="index"
        class="mr-4"
        @click="handleHeaderAction(action.action)"
      >
        {{ action.label }}
      </doe-button>
    </div>
    <div
      v-else
      class="lg:block flex-1 pt-px"
      :class="{
        'hidden': !column.onMobile,
        'md:hidden': !column.onTablet,
        'md:block': column.onTablet
      }"
      role="columnheader"
      :aria-sort="sortKey === column.value ? whatOrder(column) : false"
      v-for="(column, index) in columns"
      :key="index"
    >
      <button
        class="font-light font-sans leading-relaxed py-3 subpixel-antialiased text-sm text-black"
        :class="{
          'font-bold': sortKey === column.value,
          'cursor-pointer': column.sortable
        }"
        @click="handleSortBy(column)"
      >
        {{ column.text }}
        <span v-if="sortKey === column.value">
          <doe-icon
            v-if="sortOrders[column.value] > 0"
            icon="chevronUp"
            size="small"
          />
          <doe-icon icon="chevronDown" size="small" v-else />
        </span>
      </button>
    </div>
    <div v-if="settings.contextAction">
      <div style="height:44px;width:90px;"></div>
    </div>
    <div v-else class="lg:block flex-1 pt-px">
      <p>&nbsp;</p>
    </div>
  </div>
</template>

<script>
import DoeActionBox from "@/components/table/ActionBox";
import DoeButton from "@/components/button/Button";
import DoeIcon from "@/components/icon/Icon";

export default {
  name: "DoeHeader",
  props: {
    actions: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    settings: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    },
    isAnySelected: {
      type: Boolean,
      required: true
    },
    isAllSelected: {
      type: Boolean,
      required: true
    },
    sortKey: {
      type: String
    },
    sortOrders: {
      type: Object
    },
    hasActionBoxes: {
      type: Boolean
    }
  },
  components: {
    DoeActionBox,
    DoeButton,
    DoeIcon
  },
  methods: {
    handleSortBy(column) {
      if (column.sortable) {
        this.$emit("sortBy", column.value);
      }
    },
    handleHeaderAction(action) {
      this.$emit("header:action", {
        action: action
      });
    },
    updateAllSelectedItems($event) {
      this.$store.commit('SET_BUTTON', "selectAll");
      this.$emit("input", $event);
    },
    whatOrder(column) {
      if (this.sortOrders[column.value] > 0) {
        return "ascending";
      } else {
        return "descending";
      }
    }
  },
  computed: {
    filteredActions() {
      return this.actions.filter(action => action.inHeader === true);
    },
    hasRowActions() {
      if(this.actions.length) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
